const bedc = [
	//
	// dev roles
	//

	'god',
	'change-scopes-tool',
	'change-scope-tool',
	'dev-debug-information',
	'dev-ui-viewer',

	//
	// Permissions to identify and define boundaries for app users
	//

	'admin-user',
	'app-user',
	'internal-user',
	'saas-user',
	'client-user',
	'integration-client',

	//
	// Dashboard
	//

	'job-dashboard-user',

	//
	// Summary
	//

	'target-date-viewer',
	'target-date-updater',
	'bid-at-viewer',
	'bid-at-updater',
	'delivery-viewer',
	'delivery-updater',
	'site-address-viewer',
	'site-address-updater',

	//
	// Forms
	//

	'job-details-form-user',
	'job-details-form-reader',
	'transaction-details-form-user',
	'difficulty-form-user',
	'difficulty-form-reader',
	'difficulty-form-admin',
	'difficulty-org-form-user',
	'jrf-form-reader',
	'jrf-form-writer',
	'hitl-form-user',
	'hitl-form-client-user',
	'hitl-polygon-drawing-user',
	'volumetrics-form-user',
	'review-form-user',
	'costings-form-reader',
	'costings-form-writer',
	'ai-feedback-form-reader',
	'ai-feedback-form-writer',
	'due-at-reader',
	'due-at-updater',
	'late-work-survey-form-reader',
	'late-work-survey-form-writer',

	//
	// Integrations
	//

	'integration-linker',

	//
	// Files
	//

	'job-file-superadmin',
	'job-file-admin',
	'job-file-manager',
	'job-folder-manager',
	'job-saas-accounting-folder-access',
	'job-saas-estimator-folder-access',
	'job-saas-only-folder-access',

	//
	// Chat
	//

	'internal-chat-reader',
	'internal-chat-writer',
	'external-chat-reader',
	'external-chat-writer',
	'announcement-chat-reader',
	'announcement-chat-writer',

	//
	// Activity log
	//

	'job-activity-log-admin-user',
	'job-activity-log-internal-user',
	'job-activity-log-client-user',

	//
	// Client Teams flags
	//

	'client-team-default-qa',
	'client-team-default-tl',
	'client-team-default-owner',
	'client-team-default-chat-member',
	'client-team-sales-person',
	'client-team-customer-contact',
	'client-team-default-qa',
	'client-team-default-accounting-review-assignee',
	'client-team-default-invoicing-assignee',
	'client-team-default-production-assignee',
	'client-team-default-delivery-assignee',

	//
	// Other entities
	//

	'organization-admin',
	'franchise-admin',
	'franchise-viewer',
	'principal-admin',
	'principal-viewer',
	'client-admin',
	'customer-admin',
	'project-admin',
	'builder-admin',
	'user-admin-reader',
	'user-admin-updater',
	'user-admin-updater-ai-dev',
	'user-admin-updater-system-admin',
	'user-admin-updater-support',
	'user-admin-password-updater',
	'team-admin',

	//
	// FPC
	//

	'fpc-view',
	'fpc-measurement-viewer',
	'fpc-creator',
	'client-fpc-view',
	'client-fpc-creator',
	'fpc-debug-details-viewer',

	//
	// FPS
	//

	'bedc-fps-view',
	'client-fps-view',

	//
	// Report
	//

	'bedc-report-admin',
	'bedc-report-user',
	'bedc-report-manager',
	'design-transactions-invoice-reader',
	'client-report-user',
	'saas-manager-report',
	'saas-report',
	'customer-report-user',
	//
	// Job
	//

	'job-creator',
	'job-cancel',
	'job-admin',
	'job-superadmin',
	'job-allocator',
	'job-hold-manager',

	//
	// Transaction
	//

	'transaction-creator',
	'transaction-cancel',
	'transaction-delete',
	'transaction-admin',
	'transaction-superadmin',
	'transaction-pending-feedback',
	'transaction-rework',
	'transaction-hold-manager',

	//
	// Others dashboard related
	//

	'sees-jobs-with-all-allocation-types',
	'sees-jobs-with-all-customers',
	'bedc-job-view',
	'saas-job-view',
	'detailed-transaction-view',
	'update-transaction-owner-estimator',
	'update-transaction-owner-saas-estimator',
	'simple-job-view',
	'readonly-simple-job-view',

	//
	// Recipe Manager
	//

	'recipe-manager',
	'recipe-copy-manager',

	//
	// Whole House Module
	//
	'whole-house-form-writer',

	//
	// Stage/Statuses
	//

	'ai-stages-reader',
	'ai-stages-writer',
	'ai-stages-admin',
	'design-stage-reader',
	'design-stage-writer',
	'simple-design-stage-reader',
	'simple-design-stage-writer',
	'post-complete-statuses-writer',

	//
	// [ROME-4798] BEDC File Processing
	//

	'file-processing-stage-reader',
	'file-processing-stage-writer',

	//
	// [ROME-5389]
	// custom estimate workflow for US
	//

	'sealing-stage-reader',
	'sealing-stage-writer',

	//
	// [ROME-4942]
	// custom BRG workflow
	//

	'pricing-stage-reader',
	'pricing-stage-writer',
	'estimate-management-stage-reader',
	'estimate-management-stage-writer',
	'estimate-to-order-creator',

	//
	// ROME-5342
	// order workflow
	//

	'accounting-review-reader',
	'accounting-review-writer',
	'invoicing-reader',
	'invoicing-writer',
	'delivery-reader',
	'delivery-writer',
	'order-management-reader',
	'order-management-writer',
	'production-reader',
	'production-writer',
	'staging-reader',
	'staging-writer',
	'management-review-reader',
	'management-review-writer',

	//
	// User Profile
	//

	'user-profile-productivity',

	//
	// Employee Inventory
	//

	'estimator-list',
] as const;

const integration = [
	'integration-organization-admin',
	'integration-customer-admin',
	'integration-project-admin',
	'integration-user-identity-admin',

	'integration-job-creator',

	'integration-job-client',

	'integration-hitl-client',

	'integration-fpc-creator',

	'integration-file-creator',

	'integration-webhook-subscription-admin',
] as const;

/**
 * These are the permissions
 * set a user can assume
 */
export const roles = [...bedc, ...integration];
